import classNames from 'classnames';
import {
    COLUMN_NAMES,
    DOMAIN_LIMIT_WARNING_KEY,
    STATUS_SUB_VALUES,
    STATUS_TEXT_KEYS,
    STATUSES,
    STATUSES_COLOR_MAP,
    TABLE_KEYS,
} from './consts';
import TableCellSubdomainInput from './TableCellSubdomainInput';
import TableCellSubdomainActions from './TableCellSubdomainActions';
import TableCellIcon from '../../../../components/widgets/TableCellIcon';
import TableCellText from '../../../../components/widgets/TableCellText';
import css from './SubDomainLinkTable.css';

const createTableFieldProps = fieldName => ({
    name: fieldName,
    cellValue: fieldName ? [fieldName] : null,
});

const createBackgroundTransformation = cssClass => ({
    propName: 'tdClassName',
    dataKey: 'isCreatingDomain',
    transformation: isCreating => (isCreating ? cssClass : ''),
});

const createDomainCell = (onChangeSubdomain, subdomainError) => ({
    ...createTableFieldProps(TABLE_KEYS.DOMAIN),
    displayName: COLUMN_NAMES.DOMAIN,
    cellComponent: TableCellSubdomainInput,
    cellProps: {
        onChange: onChangeSubdomain,
        error: subdomainError,
        tdClassName: css.tableCellContent,
    },
    cellValues: [
        createBackgroundTransformation(css.backgroundCreate),
        {
            propName: 'value',
            dataKey: 'subdomain',
        },
    ],
});

const createActionCell = (
    onArchiveClick,
    onFavouriteClick,
    onCreateClick,
    onCreateCancelClick,
    subDomainsPageData
) => ({
    ...createTableFieldProps(TABLE_KEYS.ACTIONS),
    displayName: COLUMN_NAMES.ACTIONS,
    cellComponent: TableCellSubdomainActions,
    headerWidth: 130,
    cellProps: {
        onFavouriteClick,
        onArchiveClick,
        onCreateClick,
        onCreateCancelClick,
        className: css.tableCellContent,
        subDomainsPageData,
    },
    cellValues: [createBackgroundTransformation(css.backgroundCreate)],
});

const createStatusCell = translate => ({
    ...createTableFieldProps(TABLE_KEYS.STATUS),
    displayName: COLUMN_NAMES.STATUS,
    cellComponent: TableCellIcon,
    cellValues: [
        {
            propName: 'value',
            dataKey: 'status',
        },
        {
            propName: 'subValue',
            dataKey: 'status',
            transformation: status => translate(STATUS_SUB_VALUES[status]),
        },
        createBackgroundTransformation(css.backgroundCreate),
    ],
    cellProps: {
        isBold: true,
        color: STATUSES_COLOR_MAP,
        text: {
            [STATUSES.LIVE]: translate(STATUS_TEXT_KEYS.LIVE),
            [STATUSES.EDIT]: translate(STATUS_TEXT_KEYS.EDIT),
            [STATUSES.UPGRADE]: translate(STATUS_TEXT_KEYS.UPGRADE),
            [STATUSES.LIMIT_REACHED]: translate(STATUS_TEXT_KEYS.LIMIT_REACHED),
        },
    },
});

const createDomainTypeCell = () => ({
    ...createTableFieldProps(TABLE_KEYS.DOMAIN_TYPE),
    displayName: COLUMN_NAMES.DOMAIN_TYPE,
    cellComponent: TableCellText,
    headerWidth: 200,
    cellValues: [
        {
            propName: 'className',
            dataKey: 'isCreatingDomain',
            transformation: isCreating =>
                classNames(css.backgroundCreateDomain, isCreating && css.backgroundCreateDomainCreating),
        },
        {
            propName: 'rightCellElement',
            dataKey: 'favourite',
            transformation: isFavourite => !isFavourite,
        },
    ],
});

export const getAlertMessage = (subdomains, domainsLimit) => {
    return subdomains.length >= domainsLimit ? DOMAIN_LIMIT_WARNING_KEY : '';
};

export const tableColumns = (
    onArchiveClicked,
    onFavouriteClicked,
    onCreateClick,
    onCancelCreateDomain,
    onChangeSubdomain,
    validationError,
    isAgency,
    subDomainsPageData,
    translate
) => {
    const baseColumns = [
        createDomainTypeCell(),
        createDomainCell(onChangeSubdomain, validationError),
        createStatusCell(translate),
    ];

    if (!isAgency) {
        baseColumns.push(
            createActionCell(
                onArchiveClicked,
                onFavouriteClicked,
                onCreateClick,
                onCancelCreateDomain,
                subDomainsPageData
            )
        );
    }

    return baseColumns;
};
